<template>
    <div>
        <h1 style="font-size: 24px; color: black;">处理计算业务数据</h1>
        <h2 style="font-size: 18px; color: darkorange;">1.变现收入数据计算</h2>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                    <span> 处理类型： </span>
                    <el-select v-model="queryData.fcType" placeholder="请选择"  >
                        <el-option v-for="(value, key) in fcTypes"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <span> 媒体： </span>
                    <el-select v-model="queryData.mediaId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <span > 创建日期：</span>
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-col>
                    <el-button  type="primary" @click="queryList">计算</el-button>
            </el-row>
            <el-collapse v-model="activeNames" >
                <el-collapse-item title="注意事项" name="1">
                    <div style="color: darkgreen">1. adcope无法通过api接口进行获取，需要运营人员通过插件手动获取</div>
                    <div style="color: darkgreen">2. 渠道数据合并中间表只处理将各渠道表的应用及媒体广告类型统一后放进中间表，不做数据求和处理</div>
                    <div></div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
        <h2 style="font-size: 18px; color: darkorange;">2.处理代理投放合并数据</h2>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="8">
                    <span > 创建日期：</span>
                    <el-date-picker
                            v-model="timeDate1"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
                <el-button  type="primary" @click="queryProxy">计算</el-button>
            </el-row>
        </el-card>
        <h2 style="font-size: 18px; color: darkorange;">3.处理每个应用日消耗合并数据</h2>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="8">
                    <span > 创建日期：</span>
                    <el-date-picker
                            v-model="timeDate2"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
                <el-button  type="primary" @click="queryAppCost">计算</el-button>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import {
        handleDataWithMedia,
        handleDataWithAppCost,
        handleDataWithProxy,
    } from "@/http/outApi";
    import settingMix from '@/utils/mix/common-setting'
    import dateUtil from '@/utils/DateUtil'
    import utils from "@/utils";
    export default {
        name: "HandleCalData",
        mixins: [settingMix],
        data(){
            return{
                mediaType: 1, //变现媒体
                needGetMedia: true,
                mediaObj: {},
                fcTypes:{
                    1:"api拉取源数据",
                    2:'渠道数据合并中间表'
                },
                activeNames: '1',
                queryData: {
                    fcType: 1,
                    mediaId: -1,
                    timeDate: ['', ''],
                },
                timeDate1: ['', ''],
                timeDate2: ['', ''],
            }
        },
        methods :{
            queryList(){
                let queryTrueData = {fcType: this.queryData.fcType, mediaId: this.queryData.mediaId}
                queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:utils.DateUtil.formatDate(this.queryData.timeDate[0],"YYYY-MM-DD")
                queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:utils.DateUtil.formatDate(this.queryData.timeDate[1],"YYYY-MM-DD")
                handleDataWithMedia(queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                        this.$message({
                            message: '提交计算成功，由于请求为异步处理，请耐心等待片刻！',
                            center: true,
                            type: 'success',
                            duration: 5000
                        })
                    }
                })
            },
            queryProxy(){
                let startDt=this.timeDate1[0]==='' ? null:this.timeDate1[0];
                let endDt = this.timeDate1[1]==='' ? null:this.timeDate1[1];
                handleDataWithProxy(startDt,endDt).then(resp=> {
                    if (resp.data.status===0){
                        this.$message({
                            message: '提交计算成功，由于请求为异步处理，请耐心等待片刻！',
                            center: true,
                            type: 'success',
                            duration: 5000
                        })
                    }
                })
            },
            queryAppCost(){
                let startDt=this.timeDate2[0]==='' ? null:this.timeDate2[0];
                let endDt = this.timeDate2[1]==='' ? null:this.timeDate2[1];
                handleDataWithAppCost(startDt,endDt).then(resp=> {
                    if (resp.data.status===0){
                        this.$message({
                            message: '提交计算成功，由于请求为异步处理，请耐心等待片刻！',
                            center: true,
                            type: 'success',
                            duration: 5000
                        })
                    }
                })
            },

        },
        created() {
            this.queryData.timeDate = dateUtil.getIntervalDate();
            this.timeDate1 = dateUtil.getIntervalDate();
            this.timeDate2 = dateUtil.getIntervalDate()
        },
    }

</script>

<style scoped>

</style>